
import EditPage from "./EditPage";
import ListPage from "./ListPage";

const resource = {
  list: ListPage,
  edit: EditPage
};

export default resource;